export const getActiveStageTabId = (
  stageParam: string | null,
  tabStages: Array<{ id: string }>,
): string | undefined => stageParam ?? tabStages[0]?.id;
